import { LPRSession } from "@/types";
import { formatDateTime, formatDuration } from "./utils";

export function exportSessionsToCSV(
  sessions: LPRSession[],
  filename: string = "sessions.csv",
) {
  // Define CSV headers
  const headers = [
    "Session ID",
    "Entry Plate",
    "Entry State",
    "Entry Camera",
    "Entry Time",
    "Exit Plate",
    "Exit State",
    "Exit Camera",
    "Exit Time",
    "Duration (minutes)",
    "Duration (formatted)",
    "Location",
    "Match Type",
    "Is Fuzzy",
    "Fuzzy Distance",
    "State Mismatch",
  ];

  // Convert sessions to CSV rows
  const rows = sessions.map((session) => [
    session.id || "",
    session.entry_plate || "",
    session.entry_state || "",
    session.entry_camera || "",
    session.entry_time ? formatDateTime(session.entry_time) : "",
    session.exit_plate || "",
    session.exit_state || "",
    session.exit_camera || "",
    session.exit_time ? formatDateTime(session.exit_time) : "Active",
    session.duration_minutes || "",
    session.duration_minutes
      ? formatDuration(session.duration_minutes)
      : "Active",
    session.location || "",
    session.match_type || "",
    session.is_fuzzy ? "Yes" : "No",
    session.fuzzy_distance || "",
    session.state_mismatch ? "Yes" : "No",
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(","),
    ...rows.map((row) =>
      row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
    ),
  ].join("\n");

  // Create blob and download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function generateCSVFilename(prefix: string = "sessions"): string {
  const now = new Date();
  const timestamp = now.toISOString().split("T")[0]; // YYYY-MM-DD
  return `${prefix}_${timestamp}.csv`;
}

export function exportProblemPlatesToCSV(
  plates: Array<{
    plate: string;
    state: string;
    location_ids: string;
    orphan_count: number;
    last_seen: string;
    record_types: string;
  }>,
  filename: string = "problem-plates.csv",
) {
  // Define CSV headers
  const headers = [
    "Plate",
    "State",
    "Location",
    "Orphan Count",
    "Record Types",
    "Last Seen",
  ];

  // Convert plates to CSV rows
  const rows = plates.map((plate) => [
    plate.plate || "",
    plate.state || "",
    plate.location_ids || "",
    plate.orphan_count || 0,
    plate.record_types || "",
    plate.last_seen ? new Date(plate.last_seen).toLocaleDateString() : "",
  ]);

  // Combine headers and rows
  const csvContent = [
    headers.join(","),
    ...rows.map((row) =>
      row.map((cell) => `"${String(cell).replace(/"/g, '""')}"`).join(","),
    ),
  ].join("\n");

  // Create blob and download
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);

  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
